import { useState, useEffect } from 'react';
import { Tabs, Space, Table } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import Tab1 from './Tab1';
import Utilisateur from '../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../Functions/Security/Crypter';
import { Box, Tooltip, Typography, styled } from '@mui/material';
import ButtonMui from "@mui/material/Button";
//import "../../Assets/Styles/StyleForm.css";
import DataTypeTable from '../../../../Types/DataTypeTable';
import Datas from "../../../../Data/Data.json";
import { ColumnsType } from 'antd/es/table';
import { useNavigate } from 'react-router-dom';
import formatDate from '../../../../Functions/Traitement/fomatDate';
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import Garantie from '../../../../Models/Garantie';
import ParamsPicklist from '../../../../Types/ParamsPicklist';
import Tab3 from './Tab3';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import ReformatNumber from '../../../../Functions/Traitement/ReformatNumber';
import OperationCaisse from '../../../../Models/OperationCaisse';
import { LoadBilletage } from '../../../../Functions/Traitement/LoadBilletage';

const columns: ColumnsType<any> = [
  {
    title: 'Reférence',
    dataIndex: 'NUMRAP',
  },
  {
    title: 'Compte',
    dataIndex: 'NODUCP',
  },
  {
    title: 'Date',
    dataIndex: 'DATECR',
  },
  {
    title: 'Remettant',
    dataIndex: 'REMETT',
  },
  {
    title: 'CNI Remettant',
    dataIndex: 'cniremet',
  },
  {
    title: 'Montant',
    dataIndex: 'MONTAN',
  },
  {
    title: "Solde AO",
    dataIndex: 'soldeApreOpe',
  }
];



//CreateNewCLIENT
//const Swal = require('sweetalert2');
//let LinkSourceApi= require('../../Data/Data.json');

const ValidationOperation = () => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  const navigate = useNavigate()

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [sbmit, setSbmit] = useState("")

  const [Data, SetData] = useState<any[]>([]);
  const [scroll, setScrool] = useState<any>({ y: 250, x: 10 })
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [pageIsLoad, setPageIsLoad] = useState(true);

  const ThemeTable = styled(Table)(({ theme }) => ({

    ".ant-table-body ": {
      height: '185px',
      borderBottom: '1px var(--colorOpaque020) solid',
    }

  }
  ));

  setTimeout(() => {
    if (selectedRowKeys.length == 0) {
    }
    try {
      let reset = localStorage.getItem(Datas.LocalVariable.reset)
      if (reset == "1") {
        setSelectedRowKeys([])
        localStorage.removeItem(Datas.LocalVariable.reset)
      }
    }
    catch (error) {
      console.log(error)
    }
  }, 1);
  function loadAccountInformations(numcpt: string) {
    setLoading(true)
    //var data = { CodeAgence: user.codage, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: user.codage, Init: numcpt, choix: 33 }
    //alert(JSON.stringify(data))
    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.GetCompte,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherNumCpte': Crypter.encrypt(numcpt)
      }
    };

    axios(config)
      .then((response) => {
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data));

          if (res.StatutCode == 200) {
            let datas = res.Result.Table;
            //alert(JSON.stringify(datas))
            form.setFieldsValue(datas[0])

            form.setFieldValue("AUTORI", formatNumber(datas[0].AUTORI))
            form.setFieldValue("BLOQUE", formatNumber(datas[0].BLOQUE))
            form.setFieldValue("DISPON", formatNumber(datas[0].DISPON))
            form.setFieldValue("SOLDEV", formatNumber(datas[0].SOLDEV))

          }
          else {
            SweetAlert.fire({ title: res.Message, icon: 'error' })
          }
        }
        setLoading(false);

      }).catch((error) => {
        console.log(error)
        setLoading(false);
        //SweetAlert.fire({title: "Error", text : error, icon: 'error'})
      })
  }


  const onSelectChange = (newSelectedRowKeys: any) => {

    //console.log('selectedRowKeys changed: ', Data[newSelectedRowKeys]);

    loadAccountInformations(Data[newSelectedRowKeys].NODUCP)

    form.setFieldsValue(Data[newSelectedRowKeys])

    setSelectedRowKeys(newSelectedRowKeys);
    if (newSelectedRowKeys.length != 0) {
      setEnregActve(false)
      setAnnulActive(false)
    }
    form.setFieldValue("sensOpe", (Data[newSelectedRowKeys].CDLBEC == '950' || Data[newSelectedRowKeys].CDLBEC == '052') ? "VERSEMENT" : (Data[newSelectedRowKeys].CDLBEC == '951' || Data[newSelectedRowKeys].CDLBEC == '051') ? "RETRAIT" : (Data[newSelectedRowKeys].CDLBEC == '955') ? "ENVOI D'ARGENT" : "RECEPTION D'ARGENT")

    form.setFieldValue("MONTAN", formatNumber(Data[newSelectedRowKeys].MONTAN))
    form.setFieldValue("LIBOPE", Data[newSelectedRowKeys].LIBOPE.split('|')[1])
    form.setFieldValue("soldeApreOpe", formatNumber(Data[newSelectedRowKeys].soldeApreOpe))

    // chargement du billetage
    LoadBilletage({
      form: form,
      authHeader: authHeader(),
      user: user,
      Ref: Data[newSelectedRowKeys].NUMRAP,
      ColRef: "RefOperation",
      Table: 'billetageOperationLitige'
    })

  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }

  const SetStart = () => {
    setSbmit("add")
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    setModifActve(true)
    form.resetFields()
    form.setFieldValue("niveau", 900)
    localStorage.setItem(Datas.LocalVariable.reset, "0")
  }

  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
    setModifActve(false)
  }
  function handleAnulle() {
    form.resetFields()
    localStorage.clear()
    initialiazeButton()
    localStorage.setItem(Datas.LocalVariable.reset, "1")
    //localStorage.setItem(Datas.LocalVariable.resetTable, "1")
  }
  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)

  }

  function modifButton() {
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
    setAnnulActive(false)
  }


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Détail opération
        </span>
      ),
      children: <Tab1 form={form} />,
    }, {
      key: '2',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Billetage
        </span>
      ),
      children: <Tab3 form={form} />,
    }
  ];

  function ValidationOperationCaisse() {


    let data: any = Data[selectedRowKeys[0] as number]
    var newDatas = {
      NUMCPT: data.NODUCP,
      lib_CODOPE: data.LIBELL,
      CODAGE: data.AEDUCP,
      DateOpe: data.DATECR,
      nomClient: data.REMETT,
      DateVal: data.DEDEVR,
      montantOpe: data.MONTAN,
      CDDEVS: data.CDDEVS,
      refOpe: data.NUMRAP,
      CODOPE: data.CDLBEC,
      // NOMB01: form.getFieldValue("NOMB01"),
      // NOMB02: form.getFieldValue("NOMB02"),
      // NOMB03: form.getFieldValue("NOMB03"),
      // NOMB04: form.getFieldValue("NOMB04"),
      // NOMB05: form.getFieldValue("NOMB05"),
      // NOMB06: form.getFieldValue("NOMB06"),
      // NOMB07: form.getFieldValue("NOMB07"),
      // NOMB08: form.getFieldValue("NOMB08"),
      // NOMB09: form.getFieldValue("NOMB09"),
      // NOMB10: form.getFieldValue("NOMB10"),
      // NOMB11: form.getFieldValue("NOMB11"),
      // NOMB12: form.getFieldValue("NOMB12"),
      // NOMB13: form.getFieldValue("NOMB13"),
      Taxe: data.TAUX,
      CNIClient: data.cniremet,
      LieuDeliv: data.lieudelrem,
      DateDeliv: data.datdelrem,
      TypeOpe: data.sensec,
      UTISAI: form.getFieldValue("UTISAI"),
      utiVal: user.coduti,
      NLINE: data.NLINE,
      Billetages: form.getFieldValue("Billetages"),
    }
    //alert(JSON.stringify(data))
    SweetAlert.fire({
      title: "Voulez-vous valider cette opération litigieuse?",
      showCancelButton: true,
      color: "green",
      confirmButtonText: "Yes",
      confirmButtonColor: "green",
      cancelButtonColor: "darkred",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      icon: 'question'
    }).then((res) => {
      if (res.isConfirmed) {

        try {
          setLoading(true);
          let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: Datas.ApiUrl.ValidationOperationLitigieuse,
            headers: {
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: Crypter.encrypt(JSON.stringify(newDatas)),
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                if (res.StatutCode == 200) {
                  LoadLitige()
                  SweetAlert.fire({ title: res.Message, icon: "success" })
                  localStorage.setItem(Datas.LocalVariable.reset, "1")

                }
                else {
                  SweetAlert.fire({ title: res.Message, icon: "warning" })
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: error, icon: "error" })
            })

        } catch (error) {
          SweetAlert.fire({ title: 'Error ocured while getting warranties or avalistes', icon: "error" })
        }
      }
    })
  }

  if (pageIsLoad) {
    setPageIsLoad(false)
    LoadLitige()
  }

  function LoadLitige() {

    form.resetFields()
    SetData([])
    setSelectedRowKeys([])
    setEnregActve(true)
    setAnnulActive(true)

    setLoading(true)
    let config: any = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.GetLitigeByUser,
      headers: {
        'CypherUser': Crypter.encrypt(JSON.stringify(user as Utilisateur)),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };
    axios.request(config)
      .then((response) => {
        setLoading(false);
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          //alert(JSON.stringify(res))
          if (res.StatutCode == 200) {
            var datat: any[] = [];
            res.Result.map((r: any, indice: number) => {
              //console.log(JSON.stringify(data))
              datat.push({
                key: indice,
                ...r
              });
              SetData(datat);
            }
            )
          }
          else {
            //SweetAlert.fire({ title: res.Message, icon: "warning" })
          }
        }
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false);
        SweetAlert.fire({ title: error, icon: "error" })
      });
  }

  function regetLitige() {
    let data: any = Data[selectedRowKeys[0] as number]
    var newDatas = {
      NUMCPT: data.NODUCP,
      lib_CODOPE: data.LIBELL,
      CODAGE: data.AEDUCP,
      DateOpe: data.DATECR,
      nomClient: data.REMETT,
      DateVal: data.DEDEVR,
      montantOpe: data.MONTAN,
      CDDEVS: data.CDDEVS,
      refOpe: data.NUMRAP,
      CODOPE: data.CDLBEC,
      // NOMB01: form 
      Taxe: data.TAUX,
      CNIClient: data.cniremet,
      LieuDeliv: data.lieudelrem,
      DateDeliv: data.datdelrem,
      TypeOpe: data.sensec,
      UTISAI: data.codUti,
      NLINE: data.NLINE
    }
    //alert(JSON.stringify(data))
    SweetAlert.fire({
      title: "Voulez-vous rejetter cette opération litigieuse?",
      showCancelButton: true,
      color: "green",
      confirmButtonText: "Yes",
      confirmButtonColor: "green",
      cancelButtonColor: "darkred",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      icon: 'question'
    }).then((res) => {
      if (res.isConfirmed) {

        try {
          setLoading(true);
          let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: Datas.ApiUrl.RegetOperationLitigieuse,
            headers: {
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: Crypter.encrypt(JSON.stringify(newDatas)),
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                if (res.StatutCode == 200) {
                  LoadLitige()
                  SweetAlert.fire({ title: res.Message, icon: "success" })
                  localStorage.setItem(Datas.LocalVariable.reset, "1")

                }
                else {
                  SweetAlert.fire({ title: res.Message, icon: "warning" })
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: error, icon: "error" })
            })

        } catch (error) {
          SweetAlert.fire({ title: 'Error ocured while getting warranties or avalistes', icon: "error" })
        }
      }
    })
  }


  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };



  function PrintGar() {
    try {
      localStorage.setItem(Datas.LocalVariable.tabGarantie, JSON.stringify({ "columns": columns, "data": Data, "form": undefined }))
      navigate("/garranty/print")
    } catch (error) {
      SweetAlert.fire({
        title: "Warning",
        text: JSON.stringify(error),
        icon: "warning"
      })
    }
  }

  function TransfertLitige() {

  }


  return (
    <div className='tab'>
      <Typography align='center' className='formTitle'><b>{window.location.pathname} </b></Typography>
      <Spin spinning={loading} size='large' style={{ color: 'green' }} >
        <Form disabled autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <div className='bG'>
            <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button disabled={false} onClick={LoadLitige} size='large' className='bt_add' type="ghost" block>
                  Actualiser
                </Button>
                <Button size='large' onClick={ValidationOperationCaisse} className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                  Valider
                </Button>
                <Button size='large' onClick={regetLitige} className='bt_add' disabled={enregActve} type="ghost" htmlType="button" block>
                  Rejetter
                </Button>
                {/* <Button size='large' onClick={TransfertLitige} className='bt_add' disabled={enregActve} type="ghost" htmlType="button" block>
                  Transférer
                </Button> */}
                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div >
              <Tabs size='small' type="card" defaultActiveKey="1" items={items} />
              <Box display={"flex"} fontStyle="inherit" className='border-left' width={"86%"} position={"absolute"} marginTop={"-9%"}>
                <Spin spinning={loading}>
                  <Form disabled={false}>
                    <Table size='small' style={{ width: 'auto' }} rowSelection={{ ...rowSelection, type: "radio" }} columns={columns} dataSource={Data} scroll={{ y: 250, x: 10 }} pagination={{ defaultPageSize: 10, position: ["bottomRight"] }} />
                  </Form>
                </Spin>
              </Box>
            </div>
            <div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
}
export default ValidationOperation;